// Angular import
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangePasswordComponent } from 'src/app/shared/components/change-password/change-password.component';
import { AuthService } from 'src/app/shared/services/auth.service';

// third party import
import { SHARED_IMPORTS } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-nav-right',
  imports: [...SHARED_IMPORTS, RouterModule],
  templateUrl: './nav-right.component.html',
  styleUrl: './nav-right.component.scss'
})
export class NavRightComponent {
  public authService = inject(AuthService);
  private modalService = inject(NgbModal);

  changePassword() {
    const modalRef = this.modalService.open(ChangePasswordComponent, {
      centered: true,
      size: 'md',
      backdrop: true,
      keyboard: false,
    });
		modalRef.componentInstance.response.subscribe(() => {
			this.logout();
		});
  }

  logout() {
    this.authService.logout();
  }
}
